import { render, staticRenderFns } from "./RestaurantSettingModal.vue?vue&type=template&id=6ef2b040&"
import script from "./RestaurantSettingModal.vue?vue&type=script&lang=js&"
export * from "./RestaurantSettingModal.vue?vue&type=script&lang=js&"
import style0 from "./RestaurantSettingModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports